/*
 * TOPIAM Employee - Employee Identity and Access Management
 * Copyright © 2022-Present Jinan Yuanchuang Network Technology Co., Ltd. (support@topiam.cn)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export default {
  'pages.app_group.list.create': '创建分组',
  'pages.app_group.list.desc':
    '应用分组管理是一种将多个应用程序或功能按照一定的逻辑或相关性进行组织和管理的方法。通过应用分组，可以更有效地管理大量应用程序，提供更好的用户体验。',
  'pages.app_group.list.column.name': '分组名称',
  'pages.app_group.list.column.code': '分组编码',
  'pages.app_group.list.column.create_time': '创建时间',
  'pages.app_group.list.column.remark': '备注',
  'pages.app_group.list.column.app_count': '应用数量',
  'pages.app_group.list.column.type': '分组类型',
  'pages.app_group.list.column.type.default': '内置',
  'pages.app_group.list.column.type.custom': '自定义',
  'pages.app_group.list.column.option': '操作',
  'pages.app_group.list.actions.delete.title': '确定要删除此应用分组？',
  'pages.app_group.list.actions.delete.content': '删除操作无法恢复，请谨慎操作！',
  'pages.app_group.list.actions.batch_delete.title': '确定批量删除选中的应用分组吗？',
  'pages.app_group.list.actions.batch_delete.content': '删除操作无法恢复，请谨慎操作！',
  'pages.app_group.create.modal_form.title': '添加分组',
  'pages.app_group.modal_form.name': '分组名称',
  'pages.app_group.modal_form.name.placeholder': '请输入分组名称',
  'pages.app_group.modal_form.name.rule.0.message': '分组名称为必填项',
  'pages.app_group.modal_form.code': '分组编码',
  'pages.app_group.modal_form.code.placeholder': '请输入分组编码',
  'pages.app_group.modal_form.code.rule.0.message': '分组编码为必填项',
  'pages.app_group.modal_form.remark': '备注',
  'pages.app_group.modal_form.remark.placeholder': '请输入备注',
  'pages.app_group.update.modal_form.title': '修改分组',
};
